export const HEADER_HEIGHT = 60;
export const BREADCRUMB_HEIGHT = 35;
export const MESSAGE_FORM_HEIGHT = 40;
export const ORDER_TAB_HEIGHT = 46;
export const ACTION_BUTTON_HEIGHT = 60;
export const STATISTICS_HEIGHT = 53;
